import { type NodeProps, Position } from '@xyflow/react';
import EditIcon from '@mui/icons-material/Edit';

import type { NodeItem, ParentNode, DataItems } from '@models/flows';
import { Connector } from '@utils/flows';

import { useNodeError } from '@hooks/useNodeError';

import {
  ConnectionPoint,
  DeleteButton,
  ErrorToolTip,
} from '@components/Flows/components/partials/index';

import { initialValueNodeData } from '@features/chargerFlows/validation/validation-helpers';

import s from './ValueNode.module.css';

type ValueNodeProps = NodeProps & {
  onEdit: (parentNode: ParentNode, childNode: NodeItem) => void;
  onDelete: (nodeId: string) => void;
};

function ValueNode({ id, type, data, onEdit, onDelete }: ValueNodeProps) {
  const valueNodeData = data as unknown as DataItems;
  const nodeItems = valueNodeData?.items || [initialValueNodeData];
  const parentNode: ParentNode = {
    id,
    type,
    data: valueNodeData,
  };
  const valueNodeItem = nodeItems[0];
  const errors = useNodeError(id);

  const handleEdit = () => {
    onEdit(parentNode, valueNodeItem);
  };

  const displayValue =
    valueNodeItem.value != null && valueNodeItem.value !== ''
      ? String(valueNodeItem.value)
      : 'No value set';

  return (
    <div className={`${s.valueContainer} ${errors ? s.errorBorder : ''}`}>
      <h1 className={s.title}>Settings Value Node</h1>
      <ErrorToolTip isErrorVisible={Boolean(errors)} messages={errors?.messages} />
      <DeleteButton onDelete={() => onDelete(id)} />
      <div className={s.valueBlock}>
        <div className={s.valueContent}>
          <span className={s.typeTag}>{valueNodeItem.code}</span>
          <p className={s.valueLabel}>{displayValue}</p>
        </div>
        <button type="button" className={s.editButton} onClick={handleEdit}>
          <EditIcon />
        </button>
      </div>
      <ConnectionPoint type={Connector.Target} position={Position.Left} id="incoming" />
    </div>
  );
}

export default ValueNode;
